import { render, staticRenderFns } from "./input-label.vue?vue&type=template&id=319668c4&"
import script from "./input-label.vue?vue&type=script&lang=js&"
export * from "./input-label.vue?vue&type=script&lang=js&"
import style0 from "./input-label.vue?vue&type=style&index=0&id=319668c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports